import React from 'react';
import { connect } from 'react-redux';

import ModalComponent from 'apps/auth/components/utils/ModalComponent';
import NewSmsConfirmation from 'apps/auth/components/utils/NewSmsConfirmation/NewSmsConfirmation';
import SmsConfirmation from 'apps/auth/components/utils/SmsConfirmation';
import { AUTH_SETTINGS } from 'apps/auth/constants/UrlConstants';
import { ensureLibPhonenumberLoaded } from 'apps/auth/helpers/libphonenumberLoader';

const ProfileSmsConfirmModal = (props) => {
    ensureLibPhonenumberLoaded();

    return (
        <ModalComponent isIconClose>
            {props.smsConfirmation?.newSmsCodeEnabled && (
                <NewSmsConfirmation
                    smsLength={6}
                    popupRef={props.popupRef}
                    headerText={props.custom_title}
                    headerGrayText={props.deleteAccountSmsGrayText}
                    smsConfirmation={props.smsConfirmation}
                    redirectUrl={AUTH_SETTINGS}
                />
            )}
            {!props.smsConfirmation?.newSmsCodeEnabled && (
                <SmsConfirmation
                    headerText={props.custom_title}
                    headerGrayText={props.deleteAccountSmsGrayText}
                    smsConfirmation={props.smsConfirmation}
                    redirectUrl={AUTH_SETTINGS}
                />
            )}
        </ModalComponent>
    );
};
const mapStateToProps = (state) => {
    return {
        smsConfirmation: state.extra?.smsConfirmation,
        custom_title: state.messages.pageMessages.custom_title,
        deleteAccountSmsGrayText: state.messages.pageMessages.deleteAccountSmsGrayText,
    };
};
export default connect(mapStateToProps)(ProfileSmsConfirmModal);
